import React from 'react';

export default function ASZF() {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8">Általános Szerződési Feltételek</h1>
        
        <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Általános rendelkezések</h2>
            <p>
              <strong>Szolgáltató:</strong> XL Bútor és Szőnyeg<br/>
              <strong>Székhely:</strong> 4600 Kisvárda, Attila u. 61.<br/>
              <strong>E-mail:</strong> xlbutorbolt@gmail.com<br/>
              <strong>Telefon:</strong> 06 (70) 417 9210
            </p>
            <p className="mt-4">
              Ezen Általános Szerződési Feltételek (ÁSZF) a XL Bútor és Szőnyeg és ügyfelei közötti 
              szerződések alapját képezik.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Szerződés létrejötte</h2>
            <p>
              A szerződés létrejöttét a rendelés megerősítése jelenti. A szolgáltató 48 órán belül 
              megerősíti a rendelést e-mailben vagy telefonon.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Árak és fizetés</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Az árak forintban értendők, ÁFA-val együtt</li>
              <li>Fizetés készpénzzel, bankkártyával vagy átutalással lehetséges</li>
              <li>Előleg fizetés esetén a teljes összeg 50%-a</li>
              <li>Átvételkor a fennmaradó összeg fizetendő</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Szállítás és átvétel</h2>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Jótállás és reklamáció</h2>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Visszavonási jog</h2>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Felelősség</h2>
            <p>
              A szolgáltató felelőssége a szerződésben foglalt szolgáltatások teljesítésére korlátozódik. 
              Közvetett károkért nem vállal felelősséget.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Vitarendezés</h2>
            <p>
              Szerződéses viták esetén először egyeztetésre törekszünk. 
              Ha ez nem vezet eredményre, a magyar bíróságok illetékesek.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. ÁSZF módosítása</h2>
            <p>
              Jogfenntartjuk magunknak a jogot, hogy ezen ÁSZF-t módosítsuk. 
              A módosításokról a weboldalunkon keresztül tájékoztatjuk.
            </p>
          </section>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500">
              <strong>Utolsó módosítás:</strong> 2024. december
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
